import { render, staticRenderFns } from "./PaymentRequestDetails.vue?vue&type=template&id=5b663fea&"
import script from "./PaymentRequestDetails.vue?vue&type=script&lang=js&"
export * from "./PaymentRequestDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports